"use strict";

var create = function create(metadata, exports) {
  return {
    metadata: metadata,
    exports: exports
  };
};

module.exports = create;


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/graylog-web-plugin/lib/PluginManifest.js
// module id = 355
// module chunks = 0